<template>
    <div class="region-redirect-block" v-if="suggestedRedirectRegion">
        <div class="region-redirect-content">

            <div class="region-redirect-block-top justify-content-between">
                {{ text[suggestedRedirectRegion].regionChangeExplain }}
                <span @click="ignoreRegionRedirect()">
                    <icon-component :icon="fa_times()" width="15px" height="15px"/>
                </span>
            </div>

            <div class="region-redirect-block-bottom">
                <SelectBoxComponent name="Region" :options="regions" v-model="selectedRegionIso"
                                    class="cursor-pointer"
                                    triggerClass="dropdown-button"/>
                <button class="btn-v2 btn-v2-gradient" @click.prevent="confirmRegionRedirect()">
                    {{ text[suggestedRedirectRegion].regionChangeConfirm }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import cookiesEnum from "@/core/constants/cookiesEnum";
import {setCookie} from "@/core/utils/helpers/cookieHelper";
import {regionIsoEnum} from "@/core/enums/regionIsoEnum";
import SelectBoxComponent from "@/components/partials/SelectBoxComponent.vue";
import IconComponent from "@/components/global/IconComponent.vue";
import {fa_times} from "@/core/constants/icons";

const data = () => {
    return {
        store: $store,
        selectedRegionIso: regionIsoEnum.AUSTRIA,
        text: {
            at: {
                regionChangeExplain: 'Alege o altă țară pentru a vizualiza conținutul specific locației tale',
                regionChangeConfirm: 'Confirmă',
            },
            de: {
                regionChangeExplain: 'Wähle ein anderes Land aus, um für deinen Standort spezifische Inhalte anzuzeigen',
                regionChangeConfirm: 'BESTÄTIGEN',
            },
            au: {
                regionChangeExplain: 'Choose another country to see content specific to your location',
                regionChangeConfirm: 'Confirm',
            },
            uk: {
                regionChangeExplain: 'Choose another country to see content specific to your location',
                regionChangeConfirm: 'Confirm',
            },
            it: {
                regionChangeExplain: 'Scegli un altro Paese per visualizzare contenuti specifici per la tua posizione',
                regionChangeConfirm: 'Confermare',
            },
            br: {
                regionChangeExplain: 'Escolha outro país para ver conteúdo específico da sua localização',
                regionChangeConfirm: 'Confirmar',
            }
        }
    }
}

function created() {
    this.selectedRegionIso = this.suggestedRedirectRegion;
}

function confirmRegionRedirect() {
    setCookie(cookiesEnum.REDIRECT_TO_REGION_OVERRIDE, this.selectedRegionIso);

    let url = `/${this.selectedRegionIso}/`;

    if (this.selectedRegionIso === regionIsoEnum.GERMANY) {
        url = '/';
    }

    window.location.href = url;
}

function ignoreRegionRedirect() {
    setCookie(cookiesEnum.IGNORE_REGION_REDIRECT, true);
    this.store.commit('setSuggestedRedirectRegion', null);
}

export default {
    components: {IconComponent, SelectBoxComponent},
    data,
    created,
    computed: {
        ...mapState(['suggestedRedirectRegion', 'translate']),
        regions() {
            return [
                {label: 'Österreich', value: regionIsoEnum.AUSTRIA, link: `/${regionIsoEnum.AUSTRIA}/`},
                {label: 'Australia', value: regionIsoEnum.AUSTRALIA, link: `/${regionIsoEnum.AUSTRALIA}/`},
                {label: 'Brasil', value: regionIsoEnum.BRAZIL, link: `/${regionIsoEnum.BRAZIL}/`},
                {
                    label: 'United Kingdom',
                    value: regionIsoEnum.UNITED_KINGDOM,
                    link: `/${regionIsoEnum.UNITED_KINGDOM}/`
                },
                {label: 'Italia', value: regionIsoEnum.ITALY, link: `/${regionIsoEnum.ITALY}/`},
            ];
        }
    },
    methods: {
        fa_times,
        confirmRegionRedirect,
        ignoreRegionRedirect,
    },
}
</script>
